module.exports = __webpack_public_path__ + "img/KSC03618.7c9e5e4e.jpg";